import { fallbackServices } from '../data/fallbackData';

const fallbackBySlug = Object.fromEntries(
  fallbackServices.map((s) => [s.slug, s])
);

const norm = (s) => (s || '').trim();

function findFallbackPrice(apiRow, fbPrices) {
  if (!Array.isArray(fbPrices) || !fbPrices.length) return null;
  const name = norm(apiRow.name);
  let fp = fbPrices.find(
    (p) => norm(p.nameRu) === name || norm(p.name) === name
  );
  if (fp) return fp;
  return (
    fbPrices.find(
      (p) =>
        p.priceMinMnt === apiRow.priceMinMnt &&
        (p.priceMaxMnt ?? null) === (apiRow.priceMaxMnt ?? null)
    ) || null
  );
}

function enrichPriceRow(apiRow, fbRow) {
  if (!fbRow) {
    return {
      ...apiRow,
      nameRu: apiRow.nameRu || apiRow.name,
    };
  }
  return {
    ...fbRow,
    ...apiRow,
    nameMn: apiRow.nameMn || fbRow.nameMn,
    nameEn: apiRow.nameEn || fbRow.nameEn,
    nameRu: apiRow.nameRu || fbRow.nameRu || apiRow.name,
    name: apiRow.name || fbRow.name || fbRow.nameRu,
    priceMinMnt: apiRow.priceMinMnt,
    priceMaxMnt: apiRow.priceMaxMnt,
    price:
      apiRow.price !== undefined &&
      apiRow.price !== null &&
      apiRow.price !== ''
        ? apiRow.price
        : fbRow.price ?? '',
    priceTextMn: apiRow.priceTextMn || fbRow.priceTextMn,
    priceTextEn: apiRow.priceTextEn || fbRow.priceTextEn,
    priceTextRu: apiRow.priceTextRu || fbRow.priceTextRu,
    id: apiRow.id,
  };
}

/** Дополняет ответ API локализованными полями из fallback (БД пока только ru). */
export function enrichServiceFromApi(api) {
  const fb = fallbackBySlug[api.slug];
  const prices = Array.isArray(api.prices)
    ? api.prices.map((row) =>
        enrichPriceRow(row, fb ? findFallbackPrice(row, fb.prices) : null)
      )
    : [];

  if (!fb) {
    return { ...api, prices };
  }

  return {
    ...api,
    titleMn: api.titleMn || fb.titleMn,
    titleEn: api.titleEn || fb.titleEn,
    titleRu: api.titleRu || fb.titleRu || api.title,
    shortDescriptionMn: api.shortDescriptionMn || fb.shortDescriptionMn,
    shortDescriptionEn: api.shortDescriptionEn || fb.shortDescriptionEn,
    shortDescriptionRu:
      api.shortDescriptionRu || fb.shortDescriptionRu || api.shortDescription,
    fullDescriptionMn: api.fullDescriptionMn || fb.fullDescriptionMn,
    fullDescriptionEn: api.fullDescriptionEn || fb.fullDescriptionEn,
    fullDescriptionRu:
      api.fullDescriptionRu || fb.fullDescriptionRu || api.fullDescription,
    prices,
  };
}

export function enrichServicesFromApi(list) {
  if (!Array.isArray(list)) return [];
  return list.map(enrichServiceFromApi);
}
